import { motion } from 'framer-motion';

export default function Story() {
  return (
    <section id="story" className="border-t border-line/70 px-4 py-14 sm:px-5 md:py-28">
      <div className="mx-auto grid max-w-page gap-12 md:grid-cols-[0.9fr_1.1fr] md:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber">
            Why this exists
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-white md:text-4xl">
            The version of me that started this had no one to ask.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="space-y-5 text-[15px] leading-relaxed text-white/65"
        >
          <p>
            I joined Aakash for foundational courses back when the plan was olympiads, not
            NEET — NSO, IMO, PRMO, RMO, that track. I cracked the NTSE scholarship in 2021, and
            honestly, that early win did more damage than good. It made me overconfident — the
            kind where you assume you'll perform when it matters without doing the specific
            work that gets you there.
          </p>
          <p>
            That confidence cost me. Through 11th and 12th I stayed at Aakash but never really
            focused on NEET — boards took the front seat, and even that slipped to 81% once a
            relationship, and later its breakup, ate into a year I could've spent studying. I
            moved into a B.Sc. while still attending Aakash, this time actually training for
            NEET. My first real attempt still went horribly. I felt like I'd wasted years, and I
            regretted a lot of decisions.
          </p>
          <p>
            What got me through was people who didn't give up on me — my parents, and a few
            faculty at Aakash who kept pushing. I shifted my B.Sc. to distance-learning mode so
            NEET could finally get my full, undivided attention. That's what changed the outcome:
            I qualified NEET UG 2026 and I'm now an MBBS student.
          </p>
          <p>
            I'm building arpansarkar.org for the student who's currently overconfident, currently
            distracted, currently convinced they'll figure it out later — the way I was.
            Mentorship, resources and real cutoffs, from someone who made almost every mistake
            there was to make and still came through.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
